import React from 'react';
import {useNavigate} from "react-router-dom";
import MikvahSlider from '../../../components/Mikvahslider/MikvahSlider';
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import storylogo from '../../../assets/home/teaneck-logo.png';
import './CustomerStory.scss';
import { useTranslation } from 'react-i18next';

const CustomerStory = () => {

    const navigate = useNavigate();
    const { t, i18n } = useTranslation();

    const goToPage = (page) => {
        navigate(page, { replace: true });
    };
    return (
        <>
            <section className="customer-story-sec">
                <div className="container">
                    <div className="customer-story-wrapper">
                        <div className="top-header">
                            <Breadcrumb>
                                <Breadcrumb.Item onClick={ () => { goToPage('/customer-stories')}}>
                                    Customer Stories 
                                </Breadcrumb.Item>
                                <Breadcrumb.Item active onClick={ () => { goToPage('/')}}>
                                  Teaneck Mikvah
                                </Breadcrumb.Item>
                            </Breadcrumb>
                        </div>
                        <div className="customer-story-content">
                            <div className="customer-story-content-wrap">
                                <div className="left-content">
                                    <div className="story-plans">
                                        <div className="story-logo">
                                            <img src={storylogo} alt="storylogo" />
                                        </div>
                                        <div className="story-items">
                                            <div className="story-item">
                                                <span>Location</span>
                                                <h5>Teaneck, NJ</h5>
                                            </div>
                                            <div className="story-item">
                                                <span>Size</span>
                                                <h5>800+ Monthly Visitors</h5>
                                            </div>
                                            <div className="story-item">
                                                <span>Stage</span>
                                                <h5>Retrofit</h5>
                                            </div>
                                            <div className="story-item">
                                                <span>Plan</span>
                                                <h5>Full Service</h5>
                                            </div>
                                            <div className="story-item">
                                                <span>Systems used</span>
                                                <ul>
                                                    <li>Reservation System</li>
                                                    <li>Auto Scheduling</li>
                                                    <li>{t("IntDisp")}</li>
                                                    <li>Live Dashboard</li>
                                                    <li>Guidance System</li>
                                                    <li>Door Control</li>
                                                    <li>Mikvah Website</li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="right-content">
                                    <div className="story-details">
                                        <div className="story-heading">
                                            <h2 className='heading'>Teaneck Mikvah Finds the Perfect Fit: A User-Friendly System with Unmatched Support</h2>
                                        </div>
                                        <div className="story-define-contents">
                                            <p className="description">
                                            Teaneck Mikvah, a well-established facility serving the local community, undertook a major system upgrade to optimize operations and enrich the patron experience. Rather than building from scratch, they needed a solution that could be retrofitted into their existing infrastructure with minimal disruption to daily operations. After being recommended by others, they turned to Mikvahrsvp to implement a system that prioritizes ease of use, faster room turnover, and a seamless reservation process.
                                            </p>
                                            <h6 className="required-heading">The Need</h6>
                                            <p className="description">
                                            With 18 prep rooms and 4 mikvah rooms, Teaneck Mikvah serves hundreds of women every month. They needed a system that would streamline reservations, speed up cleaning and turnover, and make things as easy as possible for both patrons and attendants. Most importantly, they wanted a system that felt natural to use—no complicated processes or steep learning curves. And since the mikvah was being updated in phases, they needed a solution that could integrate into their current setup while allowing for future expansion.
                                            </p>
                                            <div className="main-story-content">
                                                <div className="story-content-bg">
                                                    <div className="story-content-items">
                                                        <p>
                                                          “One of the biggest benefits of using Mikvahrsvp is their outstanding customer support. Anytime we have a question or need assistance, their team is incredibly responsive and quick to help. Knowing we have that level of support gives us confidence that everything will continue running smoothly.”
                                                        </p>
                                                        <span>
                                                            — Rachel L. <br />
                                                            <span>Mikvah Administrator at Teaneck Mikvah</span>
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                            <h6 className="required-heading">The Solution</h6>
                                            <p className="description">
                                              Teaneck Mikvah opted for the <b>Full Service System</b>, incorporating key features that enhance both the patron experience and back-end management.
                                            </p>
                                            <ul className="mb-4">
                                                <li>Seamless Retrofitting: The system was integrated into the existing infrastructure with minimal construction, allowing operations to continue smoothly during implementation.</li>
                                                <li>Tablet Introduction: Tablets were placed at reception and select prep rooms, with plans to expand once renovations are complete. This provided immediate benefits without requiring a full overhaul.</li>
                                                <li>Online Payments: Patrons now have the convenience of paying online, reducing wait times and administrative workload.</li>
                                                <li>Streamlined Cleaning & Room Turnover: The tablet system helps attendants track room usage and cleaning schedules in real-time, significantly improving efficiency.</li>
                                            </ul>
                                            <h6 className="required-heading">The Results</h6>
                                            <p className="description">
                                              Since switching to Mikvahrsvp, Teaneck Mikvah has seen an immediate impact. The system is easy, intuitive, and makes the Mikvah process better for both patrons and staff. Some of the biggest improvements include:
                                            </p>
                                            <ul>
                                                <li>A stress-free experience for patrons – Reservations and payments are simple, and the process flows naturally.</li>
                                                <li>A smoother night for attendants – An automated schedule and faster cleaning mean less scrambling and more efficiency.</li>
                                                <li>A system that grows with them – With tablets in place and more renovations on the way, Teaneck Mikvah has a system that will keep improving with time.</li>
                                                <li>Customer support they can count on – The team at Mikvahrsvp has provided prompt assistance, ensuring ongoing reliability.</li>
                                            </ul>
                                        </div>
                                        {/* <MikvahSlider /> */}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default CustomerStory